export const getters = {
  ID: (state: any): string => state.id,
  TAB_NAVIGATION: (state: any) => state.tabNavigation,
  LOADER: (state: any) => state.loader,
  EMPLOYEE_NAME: (state: any) => state.employeeName,
  IS_NOT_FOUND: (state: any) => state.isNotFound
}
